import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

var ModalNovoGE = function (_ref) {
  var show = _ref.show;
  var onHide = _ref.onHide;
  var onCriado = _ref.onCriado;

  var [categorias, setCategorias] = useState([]);
  var [gruposGE, setGruposGE] = useState([]);
  var [gruposParaCopiar, setGruposParaCopiar] = useState([]);
  var [loadingLookups, setLoadingLookups] = useState(false);
  var [loadingSubmit, setLoadingSubmit] = useState(false);

  var [categoria, setCategoria] = useState(null);
  var [apelido, setApelido] = useState('');
  var [grupoGE, setGrupoGE] = useState(null);
  var [copiaParametrosGE, setCopiaParametrosGE] = useState(null);
  var [errors, setErrors] = useState({});

  useEffect(function () {
    if (show) {
      setCategoria(null);
      setApelido('');
      setGrupoGE(null);
      setCopiaParametrosGE(null);
      setErrors({});
      carregarLookups();
    }
  }, [show]);

  var carregarLookups = async function () {
    setLoadingLookups(true);
    try {
      var [resCat, resGG, resGEs] = await Promise.all([
        api.listarCategoriasGE(),
        api.listarGruposGELookup(),
        api.listarGruposEmpresaAdmin({}),
      ]);
      setCategorias((resCat || []).map(function (c) { return { value: c.codigo, label: c.descricao }; }));
      setGruposGE((resGG || []).map(function (g) { return { value: g.codigo, label: g.descricao }; }));
      setGruposParaCopiar((resGEs || []).map(function (g) { return { value: g.codigo, label: g.codigo + ' - ' + (g.apelido || '(sem apelido)') }; }));
    } catch (e) {
      toast.error('Erro ao carregar dados');
    } finally {
      setLoadingLookups(false);
    }
  };

  var validar = function () {
    var errs = {};
    if (!categoria) errs.categoria = 'Categoria é obrigatória';
    if (!grupoGE) errs.grupoGE = 'Grupo é obrigatório';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  var handleSubmit = async function () {
    if (!validar()) return;
    setLoadingSubmit(true);
    try {
      var res = await api.criarGrupoEmpresa({
        categoria: categoria.value,
        apelido: apelido.trim(),
        codigo_grupo_ge: grupoGE.value,
        copias_parametros_ge: copiaParametrosGE ? copiaParametrosGE.value : null,
      });
      toast.success('Grupo de Empresa criado com sucesso!');
      onCriado(res.codigo);
    } catch (err) {
      var msg = (err && err.response && err.response.data && err.response.data.message) || 'Erro ao criar Grupo de Empresa';
      toast.error(msg);
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ fontSize: '1.1rem', color: '#fff' }}>Novo Grupo de Empresa</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loadingLookups ? (
          <p className="text-center text-muted">Carregando...</p>
        ) : (
          <>
            <Form.Group>
              <Form.Label>Categoria <span className="text-danger">*</span></Form.Label>
              <Select
                value={categoria}
                options={categorias}
                onChange={setCategoria}
                placeholder="Selecione a categoria..."
                isClearable
              />
              {errors.categoria && <small className="text-danger">{errors.categoria}</small>}
            </Form.Group>
            <Form.Group>
              <Form.Label>Apelido</Form.Label>
              <Form.Control
                type="text"
                maxLength={30}
                value={apelido}
                onChange={function (e) { setApelido(e.target.value); }}
                placeholder="Nome/apelido do GE (opcional)"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Grupo <span className="text-danger">*</span></Form.Label>
              <Select
                value={grupoGE}
                options={gruposGE}
                onChange={setGrupoGE}
                placeholder="Selecione o grupo..."
                isClearable
              />
              {errors.grupoGE && <small className="text-danger">{errors.grupoGE}</small>}
            </Form.Group>
            <Form.Group>
              <Form.Label>Copiar parâmetros do GE (opcional)</Form.Label>
              <Select
                value={copiaParametrosGE}
                options={gruposParaCopiar}
                onChange={setCopiaParametrosGE}
                placeholder="Selecione um GE para copiar parâmetros..."
                isClearable
              />
              <Form.Text className="text-muted">
                Se selecionado, os parâmetros do GE escolhido serão copiados para o novo GE.
              </Form.Text>
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loadingSubmit}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={loadingSubmit || loadingLookups}
          style={{ backgroundColor: '#7bb32e', borderColor: '#7bb32e' }}
        >
          {loadingSubmit ? 'Criando...' : 'Criar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalNovoGE;
